export default "__VITE_ASSET__sTEcOhPA__"